import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Router } from '@angular/router';

import { Globals } from '../globals';
import { Observable } from 'rxjs';

export interface Suaje {
  active: boolean;
  createdAt: any;
  updatedAt: any;

  code: string;
  long: number;
  wide: number;
  height: number;
  horizontal: number;
  vertical: number;
  rows: number;
  columns: number;
  pegue: Pegue;
  other: string;
  notes: string;

  customerRef: any;
}

export interface Pegue{
  FA: boolean;
  lineal: boolean;
  esquinas4: boolean;
  NA: boolean;
}

interface SuajeId extends Suaje {
  id: string;
}


@Injectable()
export class SuajeService {

  collection: string;
  customerCollection: string;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.SUAJE_COLLECTION;
    this.customerCollection = Globals.CUSTOMER_SUPPLIER_COLLECTION;
  }

  /**
   * Get all suajes with references
   * @return {Observable} Arrays of suajes
   */
  getSuajes({customerId='', onEmpty=undefined}={}) {
    let col;
    if(customerId) col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('customerRef', '==', this.customerReference(customerId)) );
    else col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
    return col.map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(document => {
        return Observable.combineLatest(
          this.afh.docWithIds$(`${document.customerRef.path}`),
          (customerData) => ({ customer: customerData })
        ).map( data => ({ customerObj: data.customer, ...document }) );
      });
    }).mergeMap(documents => Observable.combineLatest(documents));
  }

  /**
  * Get suaje data
  * @param {string} sid - The id of the suaje
  * @return {Observable} The Suaje Object
  */
  getSuaje(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid).map(document => {
      return Observable.combineLatest(
        this.afh.docWithIds$(`${document.customerRef.path}`),
        (customerData) => ({ customer: customerData })
      ).map( data => ({ customerObj: data.customer, ...document }) );
    }).mergeMap(documents => Observable.combineLatest(documents));
  }

  /**
  * Create new suaje
  * @param {Suaje} suaje - The data of the suaje
  */
  addSuaje(suaje: any) {
    suaje.customerRef = this.customerReference(suaje.customerRef);
    this.afh.add(`${this.collection}`, suaje);
  }

  /**
   * Update current suaje
   * @param {string} sid  - The id of the suaje
   * @param {Suaje} suaje - The data of the suaje
   */
  updateSuaje(sid: string, suaje: Suaje) {
    suaje.customerRef = this.customerReference(suaje.customerRef);
    this.afh.update(`${this.collection}/${sid}`, suaje);
  }

  /**
   * Delete current suaje
   * @param {string} sid - The id of the suaje
   */
  deleteSuaje(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  customerReference(customerId){
    return this.afh.doc(`${this.customerCollection}/${customerId}`).ref;
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_suaje`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_suaje/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_suaje/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/suaje`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}

/* export class SUAJE{
  code: string;
  long: number;
  wide: number;
  height: number;
  horizontal: number;
  vertical: number;
  rows: number;
  columns: number;
  pegue: Pegue;
  other: string;
  notes: string;

  customerRef: any;

  constructor(suajeObj: any){
    this.code = suajeObj["Codigo"];
    this.long = +suajeObj["Prod Largo"].replace(',', '.');
    this.wide = +suajeObj["Prod Ancho"].replace(',', '.');
    this.height = +suajeObj["Prod Alto"].replace(',', '.');
    this.horizontal = +suajeObj["PcaPcaHoriz"].replace(',', '.');
    this.vertical = +suajeObj["PcaPcaVertical"].replace(',', '.');
    this.rows = +suajeObj["Form Filas"].replace(',', '.');
    this.columns = +suajeObj["Form Columnas"].replace(',', '.');
    this.pegue = {
      FA: suajeObj["Fondo Aut"] == 'TRUE',
      lineal: suajeObj["Lineal"] == 'TRUE',
      esquinas4: suajeObj["4Esquinas"] == 'TRUE',
      NA: suajeObj["NoAplica"] == 'TRUE'
    }
    this.other = suajeObj["PegOtro"];
    this.notes = suajeObj["Notas"];
    this.customerRef = JSON.parse(localStorage.customersJson)[suajeObj["Cliente"]];
  }
} */
